//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import List from '@/components/table';
import createSandbox from './sandBoxItem.vue';
import detailSandbox from './sandBoxDetail.vue';
import messageBox from '@/components/messageBox';
import { timestampToISO, isoToTimestamp, formattedDate } from '../utils/index';
import _ from 'lodash';

export default {
  components: {
    List,
    createSandbox,
    detailSandbox,
    messageBox,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: 'full', value: 'full' },
        { label: 'partial', value: 'partial' },
        { label: 'development', value: 'development' },
      ],
      isCloneOptions: [
        { label: '是', value: '2' },
        { label: '否', value: '1' },
      ],
      // 搜索表单
      sandBoxSearch: {
        sandbox_name: '',
        sandbox_type: '',
        sandbox_tmpl_name: '',
        is_cloned: '',
        update_by: '',
        update_time: '',
      },
      layout: [
        { name: 'sandbox_name', label: '名称' },
        { name: 'sandbox_type', label: 'Sandbox类型' },
        { name: 'sandbox_tmpl_name', label: '模版名称' },
        { name: 'is_cloned', label: '是否克隆' },
        { name: 'update_by', label: '更新人' },
        { name: 'update_time', label: '更新时间' },
        {
          name: 'desc',
          label: '描述',
        },
      ],
      // 新建窗口展示
      createVisible: false,
      detailVisible: false,
      cloneVisible: false,
      operateType: '',
      rowMessage: {},
      cloneSandbox: {
        id: 0, // 克隆的沙箱租户ID。必录
        name: '',
      },
      cloneRules: {
        name: [
          {
            required: true,
            message: '克隆沙箱名称必填且必须为英文或英文+数字，且最多10个字符',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^(?=.*[a-zA-Z])[a-zA-Z0-9]{1,10}$/,
            message: '克隆沙箱名称必须为英文或英文+数字，且最多10个字符',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'updateManage_sandbox_add',
        'updateManage_sandbox_edit',
        'updateManage_sandbox_delete',
        'updateManage_sandbox_clone',
        'updateManage_sandbox_refresh',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      // console.log('%c Line:267 🍷 jurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  methods: {
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },
    // 查看详情
    // toDetail
    toDetail(row) {
      this.rowMessage = row;
      this.detailVisible = true;
    },
    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      console.log('%c Line:281 🍊 this.sandBoxSearch', 'color:#ed9ec7', this.sandBoxSearch);
      const params = {};
      if (this.sandBoxSearch.sandbox_name) {
        params.sandbox_name = this.sandBoxSearch.sandbox_name;
      }
      if (this.sandBoxSearch.sandbox_type) {
        params.sandbox_type = this.sandBoxSearch.sandbox_type;
      }
      if (this.sandBoxSearch.sandbox_tmpl_name) {
        params.sandbox_tmpl_name = this.sandBoxSearch.sandbox_tmpl_name;
      }
      if (this.sandBoxSearch.is_cloned) {
        params.is_cloned = this.sandBoxSearch.is_cloned === '2';
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      if (this.sandBoxSearch.update_time) {
        params.update_time_begin = timestampToISO(this.sandBoxSearch.update_time[0]);
        params.update_time_end = timestampToISO(this.sandBoxSearch.update_time[1]);
      }
      return this.$request({
        url: this.$api.getSandbox,
        data: {
          offset: (pageIndex - 1) * pageSize,
          limit: pageSize,
          ...params,
        },
      }).then((res) => {
        const computedList = res.list.map((item) => ({
          ...item,
          cloned: item.is_cloned,
          is_cloned: item.is_cloned ? '是' : '否',
          update_time: formattedDate(isoToTimestamp(item.update_time)),
        }));

        return {
          list: computedList,
          total: Number(res?.total_count) || 0,
        };
      });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),
    handleReset() {
      this.sandBoxSearch = {
        sandbox_name: '',
        sandbox_type: '',
        sandbox_tmpl_name: '',
        is_cloned: '',
        update_by: '',
        update_time: '',
      };
      this.refresh();
    },
    // 增删改
    add() {
      this.operateType = 'add';
      this.createVisible = true;
    },
    edit(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    editFromDetail(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    refreshSandbox(row) {
      this.$request({
        url: this.$api.refreshSandbox,
        data: {
          tenant_id: row.id,
        },
      }).then(() => {
        this.$message({
          message:
            row.sandbox_type === 'development'
              ? '预计在1-5分钟后开始执行刷新任务'
              : '将在明天的上午0-6点执行刷新任务',
          type: 'success',
        });
      });
    },
    clone(row) {
      this.cloneVisible = true;

      this.cloneSandbox = {
        id: row.id, // 克隆的沙箱租户ID。必录
        name: '',
      };
    },
    toClone() {
      this.$refs.cloneForm.validate((valid) => {
        if (valid) {
          this.$refs.messageBox.show({
            title: '提示',
            content: '确定克隆吗?',
            titleIconType: 'warning',
            exitButton: true,
            needCancel: true,
            cancelAction: this.$refs.messageBox.close,
            confirmAction: () => {
              this.$request({
                url: this.$api.cloneSandbox,
                data: {
                  source_tenant_id: Number(this.cloneSandbox.id), // 克隆的沙箱租户ID。必录
                  name: this.cloneSandbox.name, // 本沙箱名称。必录
                },
              })
                .then(() => {
                  this.$refs.messageBox.close();
                  this.refresh();
                  this.cloneVisible = false;
                })
                .catch((err) => {
                  //  err
                  console.log('%c Line:329 🌮 err', 'color:#b03734', err);
                });
            },
          });
        } else {
          console.log('表单验证失败!');
          return false;
        }
      });
    },
    toDelete({ id }) {
      console.log(id);
      this.$message({
        message: '此功能暂无',
        type: 'warning',
      });
      // this.$refs.messageBox.show({
      //   title: '提示',
      //   content: '确定将该条sandbox信息从sandbox列表上删除？',
      //   titleIconType: 'warning',
      //   exitButton: true,
      //   needCancel: true,
      //   cancelAction: this.$refs.messageBox.close,
      //   confirmAction: () => {
      //     this.$request({
      //       url: this.$api.deleteEditProcess,
      //       data: { id },
      //       cb: () => {
      //         this.$refs.messageBox.close();
      //         this.refresh();
      //       },
      //     });
      //   },
      // });
    },
  },
};
